import React from 'react'
import PropTypes from 'prop-types'
import ProductCard from 'components/Card/ProductCard'
import { Container } from 'styles/sharedStyle'
import { ProductGridWrapper, ProductGridContainer } from './ProductGrid.style'
import CarouselItemModal from '../CarouselItemModal/CarouselItemModal'

const ProductGrid = ({ cards, enableImageFadeIn }) => {
  const productModalRef = React.useRef()
  return (
    <ProductGridWrapper as={Container} px={[0, null, 5]}>
      <ProductGridContainer>
        {cards.map((card, i) => (
          <ProductCard
            {...card}
            enableImageFadeIn={enableImageFadeIn}
            onclickProductModal={() =>
              productModalRef.current.openModal({ ...card })
            }
            key={`card_${i.toString()}`}
          />
        ))}
      </ProductGridContainer>
      <CarouselItemModal ref={productModalRef} />
    </ProductGridWrapper>
  )
}

ProductGrid.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  enableImageFadeIn: PropTypes.bool,
}

ProductGrid.defaultProps = {
  enableImageFadeIn: false,
}

export default ProductGrid
